// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetBillTosApiParameter } from "@insite/client-framework/Services/CustomersService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import {
    getOneMonthAgoDateStringWithoutTime,
    getTodayDateStringWithoutTime,
} from "@store/Framework/Common/Utilities/reportingUtils";
import { ReportOrderFrequencyModel } from "@store/Framework/Services/Reporting/ReportingModels";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { CompanyLocation } from "@store/Framework/Store/Bunzl/Pages/Reporting/LoadLocations";
import { GetReportOrderFrequencyApiParameter } from "@store/Framework/Types/types";

import { Draft } from "immer";

type ReportOrderFrequencyState = ApplicationState["bunzl"]["pages"]["reportOrderFrequency"];
const todayDateStringWithoutTime = getTodayDateStringWithoutTime();

const oneMonthAgoDateStringWithoutTime = getOneMonthAgoDateStringWithoutTime();

export const initialState: ReportOrderFrequencyState = {
    filtersOpen: true,
    locationList: undefined,
    orderFrequencyReportData: undefined,
    getReportParams: {
        startDate: oneMonthAgoDateStringWithoutTime,
        dateType: "Ordered",
        sourceType: "invoice",
        PONumbers: [],
        reportName: "",
        billableTreatment: "all",
        endDate: todayDateStringWithoutTime,
        customers: [],
        vendor: "",
        hidemode: "",
    },
};

const actions = {
    "Store/Pages/ReportOrderFrequency/BeginLoadLocations": (
        draft: Draft<ReportOrderFrequencyState>,
        action: { parameter: GetBillTosApiParameter },
    ) => {},
    "Store/Pages/ReportOrderFrequency/CompletedLoadLocations": (
        draft: Draft<ReportOrderFrequencyState>,
        action: { parameter: GetBillTosApiParameter; collection: CompanyLocation[] },
    ) => {
        draft.locationList = action.collection;
    },
    "Store/Pages/ReportOrderFrequency/BeginLoadReportOrderFrequency": (
        draft: Draft<ReportOrderFrequencyState>,
        action: { parameter: GetReportOrderFrequencyApiParameter },
    ) => {},
    "Store/Pages/ReportOrderFrequency/CompleteLoadReportOrderFrequency": (
        draft: Draft<ReportOrderFrequencyState>,
        action: { report: ReportOrderFrequencyModel },
    ) => {
        draft.orderFrequencyReportData = action.report;
    },
    "Store/Pages/ReportOrderFrequency/UpdateReportSearchFields": (
        draft: Draft<ReportOrderFrequencyState>,
        action: { parameter: GetReportOrderFrequencyApiParameter },
    ) => {
        draft.getReportParams = { ...draft.getReportParams, ...action.parameter };

        for (const key in draft.getReportParams) {
            const value = (<any>draft.getReportParams)[key];

            // remove empty parameters
            if (value === "" || value === undefined) {
                delete (<any>draft.getReportParams)[key];
            }
        }
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BunzlPagesReportOrderHistoryActions = BunzlActionUnion<typeof actions>;

export default reducer;
